<template>
  <div class="main">
    <div class="pageTitle">
      <p>字典维护</p>
    </div>
    <div class="searchArea">
      <el-form
        label-position="left"
        size="small"
        label-width="80px"
        class="searchForm"
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item label="关键字:">
          <el-input v-model="listQuery.Parameters.keyword" autocomplete="off" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="searchTable">查询</el-button>
        <el-button size="small" @click="createNewModel">新增</el-button>
        </el-form-item>
      </el-form>
     
    </div>
    <div class="tableContainer" style="top: 120px;">
      <div class="tableContent">
            <el-table :data="dataList" border stripe>
        <el-table-column type="index" width="80" label="序号"></el-table-column>
        <el-table-column prop="name" label="名称">
          <!-- <template slot-scope="props">
            <el-button type="text" size="mini" @click="getDataInfo(props.row)">{{props.row.name}}</el-button>
            
          </template>-->
        </el-table-column>
        <el-table-column prop="key" label="编码"></el-table-column>
        <el-table-column prop="name" label="操作" width="120">
          <template slot-scope="props">
            <el-button size="mini" @click="setFunc(props.row)">设置</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>
  
      <div class="tablePagesNumber">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="listQuery.PagingInfo.currentPage"
          :page-sizes="[10, 50, 100, 200]"
          :page-size="listQuery.PagingInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="listQuery.PagingInfo.totalCount"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      title="新增字典"
      :visible.sync="taskVisible"
      :close-on-click-modal="false"
      width="500px"
      @close="closeDialog('dictionaryForm')"
      :close-on-press-escape="false"
    >
      <div class="modalForm">
        <el-form
          :model="dictionaryForm"
          label-position="left"
          ref="dictionaryForm"
          size="small"
          :rules="rules"
          label-width="80px"
        >
          <el-form-item label="名称:" prop="name">
            <el-input v-model="dictionaryForm.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="代码:" prop="key">
            <el-input v-model="dictionaryForm.key" autocomplete="off" :disabled="isEdit==true"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="text" @click="removebtn()" class="delete_btn" v-if="isEdit==true">删除</el-button>
        <el-button type="text" @click="confirmbtn('dictionaryForm')">保存</el-button>
        <el-button type="text" @click="closeDialog('dictionaryForm')">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "weeklyReport",
  components: {},
  props: [],
  data() {
    return {
      dictionaryForm: {
        key: "",
        name: "",
        id: ""
      },
      dataList: [],
      listQuery: {
        PagingInfo: {
          currentPage: 1,
          totalPage: 0,
          pageSize: 10,
          totalCount: 0
        },
        OrderBy: "",
        Parameters: {
          keyword: ""
        }
      },
      selectlistQuery: {
        PagingInfo: {
          currentPage: 1,
          totalPage: 0,
          pageSize: 1000,
          totalCount: 0
        },
        OrderBy: "",
        Parameters: {
          keyword: ""
        }
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }]
      },
      taskVisible: false,
      isEdit: false
    };
  },
  mounted() {
    this.getDataList();
  },
  methods: {
    getDataList() {
      this.$dictionaryApi.getDictionaryList(this.listQuery).then(res => {
        if (res.data.successful) {
          this.dataList = res.data.data.data;
          this.listQuery.PagingInfo.totalCount =
            res.data.data.pagingInfo.totalCount;
        } else {
          this.$alert(res.data.message, "提示");
        }
      });
    },
    getDataInfo(data) {
      let id = data.id;
      this.$dictionaryApi.getDictionary(id).then(res => {
        this.treeData = [];
        if (res.data.successful) {
          this.dictionaryForm = res.data.data;
          this.isEdit = true;
          this.taskVisible = true;
        } else {
          this.$alert(res.data.message, "提示");
        }
      });
    },
    searchTable() {
      this.getDataList();
    },
    createNewModel() {
      this.isEdit = false;
      this.taskVisible = true;
    },
    confirmbtn(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return;
        let submitForm = JSON.parse(JSON.stringify(this.dictionaryForm));
        if (this.isEdit) {
          this.$dictionaryApi.updateDictionary(submitForm).then(res => {
            if (res.data.successful) {
              this.getDataList();
              this.taskVisible = false;
            } else {
              this.$alert(res.data.message, "提示");
            }
          });
        } else {
          delete submitForm.id;
          delete submitForm.createTime;
          this.$dictionaryApi.createDictionary(submitForm).then(res => {
            if (res.data.successful) {
              this.getDataList();
              this.taskVisible = false;
            } else {
              this.$alert(res.data.message, "提示");
            }
          });
        }
      });
    },
    removebtn() {
      this.$confirm("是否确定删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let id = this.dictionaryForm.id;
        this.$dictionaryApi.removeDictionary(id).then(res => {
          if (res.data.successful) {
            this.getDataList();
            this.taskVisible = false;
          } else {
            this.$alert(res.data.message, "提示");
          }
        });
      });
    },
    setFunc(currentLine) {
      this.$router.push({
        path: "/setting/dictionaryItem",
        query: { id: currentLine.id, name: currentLine.name }
      });
    },
    handleSizeChange(val) {
      this.listQuery.PagingInfo.pageSize = val;
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.listQuery.PagingInfo.currentPage = val;
      this.getDataList();
    },
    closeDialog(formName) {
      this.resetObj(this.dictionaryForm);
      this.$refs[formName].resetFields();
      this.isEdit = false;
      this.taskVisible = false;
    },
    resetObj(dataObj) {
      for (var i in dataObj) {
        dataObj[i] = "";
      }
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/setting/dictionary.vue